import styled, { css } from 'styled-components';

interface ContainerProps {
  height: number;
  maxHeight: number;
}
interface SpaceBarProps {
  color: string;
}

export const Container = styled.div<ContainerProps>`
  width: '100%';
  ${({ height, maxHeight }) => css`
    height: ${height};
    max-height: ${maxHeight};
  `};
`;

export const EmptyData = styled.div`
  padding-top: 10px;
  pointer-events: none;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 11px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: overlay;
`;

export const SpaceBar = styled.div<SpaceBarProps>`
  height: 1px;
  margin-bottom: 2px;
  border-radius: 5px;
  width: 100%;
  background-color: ${({ color }) => color};
`;

export const ContentTable = styled.div<ContainerProps>`
  width: '100%';
  ${({ height, maxHeight }) => css`
    height: ${height};
    max-height: ${maxHeight};
  `};
`;

export const Center = styled.div`
  height: 70;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
